import controller from './company-settings.controller';

const template = require('./company-settings.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/company-settings/company-settings.component.js